import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import i18n from '../i18n';

const STORAGE_KEY = 'app_language';

export function useAppLanguage() {
	useEffect(() => {
		// Получаем сохранённый язык
		const savedLang = localStorage.getItem(STORAGE_KEY);

		if (savedLang) {
			i18n.changeLanguage(savedLang);
			return;
		}

		// Определяем язык пользователя на основе Telegram и списка поддерживаемых локалей
		const rawUserLang = WebApp?.initDataUnsafe?.user?.language_code || 'en';
		const normalizedUserLang = String(rawUserLang).toLowerCase().split('-')[0];
		const supportedLangs = Object.keys(i18n.options?.resources || {});
		const detectedLang = supportedLangs.includes(normalizedUserLang) ? normalizedUserLang : 'en';

		// Устанавливаем язык
		i18n.changeLanguage(detectedLang);
		localStorage.setItem(STORAGE_KEY, detectedLang);
	}, []);

	const changeLanguage = (lang) => {
		i18n.changeLanguage(lang);
		localStorage.setItem(STORAGE_KEY, lang);
	};

	return {
		currentLanguage: i18n.language,
		changeLanguage
	};
} 